var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#202124",
    fillRule: "evenodd",
    d: "M1.587 12a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1M9.88.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414l-4.293-4.293-4.293 4.293A1 1 0 0 1 4.88 5.293z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#202124",
    fillRule: "evenodd",
    d: "M10.587 0a1 1 0 0 1 1 1v12a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;